import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import "./CAMDrawer.scss";
import { action } from "../../constants/action";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import AutoAwesomeMosaicOutlinedIcon from "@mui/icons-material/AutoAwesomeMosaicOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import HexagonOutlinedIcon from "@mui/icons-material/HexagonOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  investigatorRoutes,
  analyticsRoutes,
  manageDataRoute,
  configuration,
} from "../../routes/routeConstants";

const CAMDrawer = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const {
    TASKSTATUS,
    AUDITTRAIL,
    SEARCH,
    VISUALIZATION,
    DATAPREVIEW,
    TASKSTATUSNEW,
    AUDITTRAILNEW,
    PROCESS,
    LIMIT,
    MANAGE_DATA,
    PROCESS_CONFIG,
  } = action;
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const userSubRole = localStorage.getItem("userSubRole");
  const handleListItemClick = (event, index, path) => {
    setSelectedIndex(index);
    navigate(path);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div
      className="root"
      onMouseEnter={handleDrawerOpen}
      onMouseLeave={handleDrawerClose}
    >
      <Drawer
        variant="permanent"
        open={open}
        className={`drawer ${open ? "drawerOpen" : "drawerClose"}`}
        classes={{
          paper: `${open ? "drawerOpen" : "drawerClose"} drawer`,
        }}
        sx={{
          width: open ? 170 : 50,
          flexShrink: 0,
          whiteSpace: "nowrap",
          overflowX: "hidden",
          transition: "width 300ms cubic-bezier(0.4, 0, 0.2, 1)",
          "& .MuiDrawer-paper": {
            width: open ? 170 : 50,
            transition: "width 300ms cubic-bezier(0.4, 0, 0.2, 1)",
            overflowX: "hidden",
          },
        }}
      >
        <div>
          <List style={{ padding: "20px 5px" }}>
            <ListItem disablePadding>
              <ListItemButton
                // disabled
                onClick={(event) =>
                  handleListItemClick(
                    event,
                    1,
                    `/${investigatorRoutes.taskStatus}`,
                  )
                }
                className={` list-item-button
                  ${
                    window.location.pathname ===
                    `/${investigatorRoutes.taskStatus}`
                      ? "list-item-button-selected"
                      : "list-item-button-not-selected"
                  }  `}
              >
                <ListItemIcon className="listItemIcon">
                  <AssignmentTurnedInOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={TASKSTATUS} />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                // disabled
                onClick={(event) =>
                  handleListItemClick(event, 3, `/${investigatorRoutes.logs}`)
                }
                className={` list-item-button
                  ${
                    window.location.pathname === `/${investigatorRoutes.logs}`
                      ? "list-item-button-selected"
                      : "list-item-button-not-selected"
                  }  `}
              >
                <ListItemIcon className="listItemIcon">
                  <ListAltOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={AUDITTRAIL} />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                // disabled
                onClick={(event) =>
                  handleListItemClick(
                    event,
                    4,
                    `/${investigatorRoutes.investigationAnalysis}`,
                  )
                }
                className={` list-item-button
                ${
                  window.location.pathname ===
                  `/${investigatorRoutes.investigationAnalysis}`
                    ? "list-item-button-selected"
                    : "list-item-button-not-selected"
                }  `}
              >
                <ListItemIcon className="listItemIcon">
                  <ZoomInOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={SEARCH} />
              </ListItemButton>
            </ListItem>

            <ListItem disablePadding>
              <ListItemButton
                // disabled
                onClick={(event) =>
                  handleListItemClick(
                    event,
                    5,
                    `/${investigatorRoutes.filesPreview}`,
                  )
                }
                className={` list-item-button
                  ${
                    window.location.pathname ===
                    `/${investigatorRoutes.filesPreview}`
                      ? "list-item-button-selected"
                      : "list-item-button-not-selected"
                  }  `}
              >
                <ListItemIcon className="listItemIcon">
                  <PreviewOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={DATAPREVIEW} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                onClick={(event) =>
                  handleListItemClick(
                    event,
                    6,
                    `/${manageDataRoute.reviewBatches}`,
                  )
                }
                className={` list-item-button
                ${
                  window.location.pathname ===
                  `/${manageDataRoute.reviewBatches}` ||
                    window.location.pathname ===
                  `/${manageDataRoute.reviewList}`
                    ? "list-item-button-selected"
                    : "list-item-button-not-selected"
                }  `}
                // disabled={true}
              >
                <ListItemIcon className="listItemIcon">
                  <VerifiedOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={MANAGE_DATA} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                onClick={(event) =>
                  handleListItemClick(
                    event,
                    6,
                    `/${analyticsRoutes.visualizationInterface}`,
                  )
                }
                className={` list-item-button
                ${
                  window.location.pathname?.includes("analytics")
                    ? "list-item-button-selected"
                    : "list-item-button-not-selected"
                }  `}
                // disabled={true}
              >
                <ListItemIcon className="listItemIcon">
                  <AutoAwesomeMosaicOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={VISUALIZATION} />
              </ListItemButton>
            </ListItem>
            {userSubRole === "srm_admin" && (
              <ListItem disablePadding>
                <ListItemButton
                  onClick={(event) =>
                    handleListItemClick(
                      event,
                      6,
                      `/${configuration.paramterList}`,
                    )
                  }
                  className={` list-item-button
                ${
                  window.location.pathname?.includes("conf")
                    ? "list-item-button-selected"
                    : "list-item-button-not-selected"
                }  `}
                  // disabled={true}
                >
                  <ListItemIcon className="listItemIcon">
                    <SettingsOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary={PROCESS_CONFIG} />
                </ListItemButton>
              </ListItem>
            )}
            {/* <ListItem disablePadding>
              <ListItemButton
                onClick={(event) =>
                  handleListItemClick(event, 6, `/${analyticsRoutes.process}`)
                }
                className={` list-item-button
                ${
                  window.location.pathname?.includes('process')
                    ? "list-item-button-selected"
                    : "list-item-button-not-selected"
                }  `}
                // disabled={true}
              >
                <ListItemIcon className="listItemIcon">
                  <AutoAwesomeMosaicOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={PROCESS} />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                onClick={(event) =>
                  handleListItemClick(event, 6, `/${analyticsRoutes.limit}`)
                }
                className={` list-item-button
                ${
                  window.location.pathname?.includes('limit')
                    ? "list-item-button-selected"
                    : "list-item-button-not-selected"
                }  `}
                // disabled={true}
              >
                <ListItemIcon className="listItemIcon">
                  <AutoAwesomeMosaicOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary={LIMIT} />
              </ListItemButton>
            </ListItem> */}
          </List>
        </div>
      </Drawer>
    </div>
  );
};

export default CAMDrawer;
